import Swal from 'sweetalert2';


export function exibirToast(icon: any, mensagem: string, position: any = 'top' ) {
    const Toast = Swal.mixin({
        toast: true,
        position: position,
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    Toast.fire({
        icon: icon,
        title: mensagem
    });
}

export function exibirSwal(
    icon: any,
    title: string,
    message: string,
    positionAlert: any = 'center',
    timer: number = 3000
) {
    Swal.fire({
        title: title,
        icon: icon,
        html: message,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3E2414',
        position: positionAlert,
        timer: timer
    });
}

export function exibirToastComLargura(icon: any, mensagem: string, position: any = 'top', width: number) {
    const Toast = Swal.mixin({
        toast: true,
        position: position,
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        width: width + 'px',
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    Toast.fire({
        icon: icon,
        title: mensagem
    });
}